import { render, staticRenderFns } from "./AccountSettingChangePasswordView.vue?vue&type=template&id=20f804c0&"
import script from "./AccountSettingChangePasswordView.vue?vue&type=script&lang=ts&"
export * from "./AccountSettingChangePasswordView.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSettingChangePasswordView.vue?vue&type=style&index=0&id=20f804c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports